import { render, staticRenderFns } from "./LookAppProducts.vue?vue&type=template&id=3b7a9e07&scoped=true&"
import script from "./LookAppProducts.vue?vue&type=script&lang=js&"
export * from "./LookAppProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7a9e07",
  null
  
)

export default component.exports